<template>
  <v-card flat color="white" class="pa-2">
    <v-overlay
      v-if="overlayMessage"
      color="secondary"
      opacity="0.7"
      absolute
      z-index="4"
    >
      <v-sheet
        class="rounded-lg pa-1 px-4 mx-auto transition-swing primary subtitle-1"
        width="100%"
        v-text="overlayMessage"
      />
    </v-overlay>
    <v-card-text class="px-0 py-0">
      <v-row no-gutters>
        <v-col
          v-for="(column, columnIndex) in columns"
          :key="`column-${columnIndex}`"
          :style="{ 'width': column.width }"
          cols="auto"
          class="px-1 mx-0 py-0 gantt-column"
        >
          <div
            v-for="(task, taskIndex) in column.tasks"
            :key="`task-${columnIndex}-${taskIndex}`"
            :style="{ 'width': task.width }"
          >
            <v-progress-linear
              :value="task.progress"
              :height="height"
              :color="$options.colors[task.color]"
              :class="{ 'gantt-highlighted-task': task.highlighted }"
              class="my-1"
            >
              <strong v-text="`${task.text}`" />
            </v-progress-linear>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _maxBy from 'lodash/maxBy'
import _sumBy from 'lodash/sumBy'

export default {
  name: 'GanttChart',
  props: {
    value: {
      type: Array,
      required: true,
    },
    overlayMessage: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 20,
    },
    highlightKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    totalSize () {
      return _sumBy(this.value.map(tasks => _maxBy(tasks, 'size')), 'size')
    },
    columns () {
      return this.value.map(tasks => {
        const maxTask = _maxBy(tasks, 'size')
        const percent = Math.round((maxTask.size / this.totalSize) * 10000) / 100
        return {
          width: `${percent}%`,
          tasks: tasks
            .slice()
            .sort((a, b) => b.size - a.size)
            .map(task => ({
              color: task.resource,
              text: `${task.done || 0}/${task.size}`,
              progress: ((task.done || 0) / task.size) * 100,
              width: `${Math.round((task.size / maxTask.size) * 10000) / 100}%`,
              highlighted: this.highlightKey && task[this.highlightKey],
            })),
        }
      })
    },
  },
  colors: {
    red: 'red lighten-1',
    green: 'green lighten-1',
    yellow: 'amber lighten-1',
    blue: 'indigo lighten-1',
  },
}
</script>

<style lang="scss" scoped>
  .gantt-column {
    background: #f3f3f3;

    &:nth-child(odd) {
      background: #e8e8e8;
    }
  }

  .gantt-highlighted-task {
    border: 3px dashed red;
    border-radius: 5px;
  }
</style>
